<div class="col p-0">
  <div class="wardSelectInstitution">
    <div class="institution-name">
      <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'>
        {{selectedInstitution}}
        <a class="menuLink tooltipEvalution">
          <img src="assets/img/svg/icon-change.svg">
          <span class="tooltiptext">{{ 'LAYOUT_MODULE.CHANGE_INSTITUTION' | translate }}</span>
        </a>
      </p>
      <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName()}}</p>
    </div>
  </div>

  <div class="d-flex justify-content-end my-3 set-container-column">
    <div class="search-box">
      <div class="col-auto p-0">
        <button class="btn-bd-empty" (click)="addNew()">{{ 'CONFIGURE.ADD_NEW' | translate }}</button>
      </div>
      <div class="col-auto row p-0 ">
        <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
        <button class="filter-button" (click)="toggleFilter()">
          <mat-icon outline class="icon-size">filter_list</mat-icon>
          {{ 'EVALUATION.FILTER' | translate }}
          <span class="filter-count">{{filterCount}}</span>
        </button>
      </div>
    </div>
    <div class="col chips">
      <span class="resultBox" *ngIf="selectedDateRange[0] != null && selectedDateRange[1] != null"> {{ selectedDateRange[0] | date :
        'dd.MM.yyyy' }} - {{ selectedDateRange[1] | date : 'dd.MM.yyyy' }}<a (click)="clearDate();"><img
            src="assets/img/SOP-Images/icon-close.svg" class="closeIcon"></a>
      </span>
      <span class="resultBox" *ngFor="let status of selectedStatuses">
        {{'INSTITUTION_MANAGEMENT.STATUS' | translate}}:
        <span class="bold">{{ getStatusText(status) | translate }}</span>
        <a (click)="clearStatus(status);">
            <img src="assets/img/SOP-Images/icon-close.svg" class="closeIcon">
        </a>
    </span>

    </div>
    <div class="col-12 static-card">
      <bd-light-table #grid [gridData]="gridData || [] | search:searchText:['wardTrl','departmentNameTrl'] "
        [pageInfo]="pageInfo" [fields]="fields" [actions]="actionItems" [actionsLast]=true [addNewRow]=true
        [inlineAddRow]=true (addNewRowCallback)="addNew()">
      </bd-light-table>
    </div>
  </div>
</div>

<lib-ph-bhp-sidepanel [showsidebar]="showFilter" (childData)="getEventShowFilter($event)">
  <div class="filter-menu">
    <div class="sidebar-header">
      <h2>{{'EVALUATION.FILTER' | translate}}</h2>
      <button class="clean-filters" (click)="resetFilters()">{{'GENERAL.CLEAN_FILTERS' | translate}}</button>
    </div>

    <div class="filter-section">
      <h3>{{'INSTITUTION_MANAGEMENT.STATUS' | translate}}</h3>
      <div class="status-buttons">
        <button class="status-button" [class.selected]="statuses.includes(0)"
          (click)="selectStatus(0)">{{getStatusText(0)}}</button>
        <button class="status-button" [class.selected]="statuses.includes(1)"
          (click)="selectStatus(1)">{{getStatusText(1)}}</button>
        <button class="status-button" [class.selected]="statuses.includes(3)"
          (click)="selectStatus(3)">{{getStatusText(3)}}</button>
        <button class="status-button" [class.selected]="statuses.includes(2)"
          (click)="selectStatus(2)">{{getStatusText(2)}}</button>
      </div>
    </div>

    <div class="filter-section">
      <h3>{{'GENERAL.TIMEFRAME' | translate}}</h3>
      <div class="date-picker-row col-12 p-0">
        <div class="col-6 p-0">
          <mat-form-field appearance="fill" class="date-form-field"
            [ngClass]="{'is-invalid': checkDatesNotValid() && dateRange[0] == null}">
            <input (click)="startDatepicker.open()" placeholder="{{'CONFIGURE.START_DATE' | translate}}" matInput
              [matDatepicker]="startDatepicker" [(ngModel)]="dateRange[0]" [max]="dateRange[1]" readonly>
            <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatepicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-6 p-0">
          <mat-form-field appearance="fill" class="date-form-field"
            [ngClass]="{'is-invalid': checkDatesNotValid() && dateRange[1] == null}">
            <input (click)="endDatepicker.open()" placeholder="{{'CONFIGURE.END_DATE' | translate}}" matInput
              [matDatepicker]="endDatepicker" [(ngModel)]="dateRange[1]" [min]="dateRange[0]" readonly>
            <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="sidebar-footer col-12">
      <button class="btn-bd-empty col-6" (click)="toggleFilter()">{{ translationKeys.Button.Cancel
        | translate}}</button>
      <button class="btn-bd col-6" (click)="saveFilter()">{{translationKeys.Authorization.Save
        | translate}}</button>
    </div>
  </div>

</lib-ph-bhp-sidepanel>

<ng-template #delmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg">
    </a>
  </div>
  <div class="modal-body">
    <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'AUTHORIZATION.CANCEL' |
        translate }}</button>
      <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' |
        translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #template>
  <div class="modal-header justify-content-between align-items-center">
    <h5 class="modal-title" id="exampleModalLabel">{{ translationKeys.UserProfiles.SelectInsititutions | translate }}
    </h5>
    <a class="cursor" aria-label="Close" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body" data-simplebar class="change-lang">
    <div [formGroup]="mygroup" class="col-12">
      <div class="mb-2 form-check" *ngFor='let Institutions of InstitutionsList;let i = index'>
        <input type="radio" [value]="Institutions.institution.institutionID" name="selectedIns"
          *ngIf="showInstitutionDropDown()" formControlName="selectedIns" class="form-check-input"
          id={{Institutions.institution.institutionID}}>
        <label class="form-check-label"
          for={{Institutions.institution.institutionID}}>{{Institutions.institution.institutionName}}</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-6 my-3">
          <button type="button" class="btn btn-continue-bordered-bd"
            (click)="onInstitutionChange(mygroup.value.selectedIns);modalRef.hide();">{{
            translationKeys.Authorization.Done |
            translate }}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
